

import { Component, Vue, Prop, Inject, Provide } from "vue-property-decorator"

import vSelect from "vue-select"
import { BModal } from "bootstrap-vue"

import DataForm from "./DataForm.vue"
import FieldPermissions from "./Permissions/FieldPermissions.vue"
import MapDisplay from "@/components/Controls/Map.vue"

import { MapProvider } from "@/services/mapProvider"
import ConfigurationColumn from "@/types/configurationColumn"

@Component({
	components: {
		"v-select": vSelect,
		"field-permissions": FieldPermissions,
		"data-form": DataForm,
		"map-display": MapDisplay
	}
})
export default class DataModal extends Vue {
	$refs!: {
		editModal: BModal;
		scrollbar: any;
	}

	@Inject("mapProvider") parentMapProvider!: MapProvider;
	@Provide("mapProvider") mapProvider: MapProvider = new MapProvider();

	@Prop()
	title!: string;

	@Prop()
	columns!: ConfigurationColumn[];

	@Prop()
	canEdit!: boolean;

	@Prop({ type: Boolean, default: false })
	allowMap!: boolean;

	@Prop({ type: String, default: "xl" })
	public modalSize!: string;

	@Prop()
	public deleteDetails!: (item: any) => any;

	@Prop()
	public canDeleteItem!: (item: any) => boolean;

	@Prop()
	public canConfirmDelete!: (item: any) => boolean;

	public deleteConfirmButtonDisabled: boolean = false;
	public saveButtonDisabled: boolean = false;

	itemOverrideColumns: any[] | null = null;
	item: any = null;

	canDelete: boolean = false;
	confirmDelete: boolean = true;
	deleteConfirmText: string = "";
	deleteDetailsItem: any = null;
	deleting: boolean = false;

	public valid: boolean = false;

	public async open (item: any, itemOverrideColumns: any[] | null = null) {
		this.canDelete = this.canDeleteItem ? await this.canDeleteItem(item) : true
		this.confirmDelete = this.canConfirmDelete ? await this.canConfirmDelete(item) : true

		this.deleting = false
		this.deleteConfirmText = ""

		this.itemOverrideColumns = itemOverrideColumns
		this.item = item
		this.$refs.editModal.show()
	}

	public get displayColumns () {
		if (this.itemOverrideColumns) {
			return this.itemOverrideColumns
		}

		return this.columns
	}

	public get showMap () {
		return this.allowMap && this.columns.some(
			c => c.dataType === "map-marker" ||
			c.dataType === "map-path" ||
			c.dataType === "map-region"
		)
	}

	public get isDeleteButtonDisabled () : boolean {
		return this.item && (this.deleteConfirmButtonDisabled || (
			this.item.name
				? this.deleteConfirmText !== this.item.name
				: this.item.title ? this.deleteConfirmText !== this.item.title : false)
		)
	}

	public save () {
		this.$emit("save", this.item)
		this.hide()
	}

	public async deleteItem () {
		if (this.deleteDetails) {
			this.deleteDetailsItem = await this.deleteDetails(this.item)
		}

		this.deleting = true
	}

	public async deleteConfirm () {
		if (!this.isDeleteButtonDisabled) {
			this.$emit("delete", this.item)
			this.hide()
		}
	}

	public isSaveButtonDisabled () : boolean {
		return this.saveButtonDisabled || !this.valid
	}

	private hide () {
		this.$refs.editModal.hide()
	}
}

